/**
 * @generated SignedSource<<fa36fd9f05080dd53ed68b0e6a9e400e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ParentCell$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ParentCell_inlineEdit">;
  readonly " $fragmentType": "ParentCell";
};
export type ParentCell$key = {
  readonly " $data"?: ParentCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"ParentCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "ParentCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isInlineEditingEnabled",
          "variableName": "isInlineEditingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ParentCell_inlineEdit"
    }
  ],
  "type": "JiraParentIssueField"
};

(node as any).hash = "8db06abab86f044a74a0380e75e7b907";

export default node;
